import React from 'react';
import classnames from 'classnames';
import styles from './QuickReplyButtonsBlock.module.scss';
const QuickReplyButtonsBlock = ({ messageBlock, error, background }) => (React.createElement("div", { className: styles.buttonsBlock }, messageBlock.buttons.map((button, i) => (React.createElement("button", { key: i, className: classnames(styles.button, { [styles.error]: error }), disabled: true },
    React.createElement("p", { className: styles.text }, button.text))))));
export default QuickReplyButtonsBlock;
